import { INVENTORY_URL } from '../../../utils/constants';
import { useSharedApps } from '../../../utils/sitecoreContext';
import useGetLinkSearchParams from './useGetLinkSearchParams';
const generateSearchParamsPayload = ({ dealerCode, providerService, modelKey, modelYear }) => ({
    modelYear,
    modelKey,
    dealerCode,
    providerService,
});
const useGetInventoryUrl = () => {
    const viewInventoryBaseUrl = useSharedApps(INVENTORY_URL);
    const viewInventoryParams = useGetLinkSearchParams({
        providerService: '',
        // override default payload structure, swap model + lang with modelKey
        generatePayload: generateSearchParamsPayload,
    });
    return `${viewInventoryBaseUrl}?${viewInventoryParams}`;
};
export default useGetInventoryUrl;
